import { ParsedQs } from "qs";

/**
 * Parse a boolean from a URL.
 * @param value Parameter string from a URL.
 * @returns     Parameter a boolean.
 */
export const parseUrlBoolean = (value: string | ParsedQs | string[] | ParsedQs[] | undefined) => {
    return typeof value === "string" && value.trim().toLowerCase() === "true";
};
